import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from "vue";
import QRCode from "qrcode-svg-ts";
import { Conversation } from "@/interfaces/conversation";

import { Message } from "@/interfaces/message";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderPrintModal',
  props: {
    conversation: {},
    boxes: {},
    printBoxes: {}
  },
  setup(__props: any) {

const iframe = ref<HTMLIFrameElement | null>();

const props = __props;

onMounted(() => {
  window._paq.push([
    "trackEvent",
    "PrintModal",
    "open box print modal",
    undefined,
  ]);

  if (iframe.value && iframe.value.contentWindow) {
    let svgs = "";
    let sender = props.conversation.senderCareProviderGroup;

    for (let box of props.printBoxes) {
      if (!box.medication_box) continue;
      if (box.medication_box.deleted) continue;
      let svg = new QRCode({
        content: `umanabox-${props.conversation.id}-${box.id}`,
        padding: 0,
        width: 100,
        height: 100,
      }).svg();
      svgs += `
      <div class='element'>
        <div>
            <h2>${box.medication_box.name ?? "unbenannte Kiste"}</h2>
            <p>${sender.group_name}<br>${box.medication_box.address1}<br>${
        box.medication_box.address2
      }<br>${box.medication_box.zip} ${box.medication_box.city}</p>
            <p><br>Bestellnr: #${props.conversation.id}<br>Boxnr. #${box.id}</p>
        </div>
        <div class='svg'>${svg}</div>
    </div>`;
    }
    let html = `
    <title>Etikett</title>
    <style>
    @page { margin: 0; }
    @media print
{    
    .no-print, .no-print *
    {
        display: none !important;
    }
}

        html {
            width: 100%;
        }
        body {
            padding: 20px;
        }
       
        .element {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px;
        } 
     
     
    </style>
    ${svgs}
    <button onclick='print();' style='position: fixed; right: 5px; bottom: 5px;' class='no-print'>Drucken</button>
    `;

    iframe.value.contentWindow.document.open();
    iframe.value.contentWindow.document.write(html);
    iframe.value.contentWindow.document.close();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("iframe", {
      class: "w-full rounded border-2 h-96 mt-s",
      ref_key: "iframe",
      ref: iframe
    }, null, 512)
  ]))
}
}

})